import { Spinner } from "react-bootstrap";
import 'assets/css/Loading.css';

export default function SingleLoading() {
    return <div className="overlay all-screen container-loading row m-0">
        <Spinner animation="border" role="status" className='m-auto' />
    </div>
}

